module.exports = __webpack_public_path__ + "img/pay-sbp-gray.7d12ad3b.svg";